<template>

    <div>
       <div class="mobile_overlay" @click="toggleFilterVisibilty" :class="{'show_overlay': !showFilter}"></div>
        <div class="filter_overlay" :class="{ cyo_jew_mobile : showFilter}">    
            <div class="filter_block" :class="{'filter_block_mod': page === 'shop'}">
                <div class="filter_block_left">

                    <div class="for_mobile filter_header">
                        <div class="close_title">
                            <SvgHeaderSvg class="for_mobile" :type="'filter_burger'" />
                            <p class="mb-0">Filters</p>
                        </div>
                        <div class="filter_close">
                            <div class="reset" @click="resetFilters"> <SvgHeaderSvg :type="'loader_mob'" />Reset</div>
                            <div class="" @click="toggleFilterVisibilty()"><SvgHeaderSvg :type="'close'" class="largesvg" /></div>
                        </div>
                    </div>

                    <div class="flex-wrap w-100 d-flex align-items-center filters_container">
                        <div class="filter_box" v-if="!['gift_card'].includes(moduleSubType)">
                            <FilterSingleSelectDropDown :name="'metal'" />
                        </div>
                        <div class="filter_box" v-if="['ring','band-ring', 'anniversary-ring', 'in-stock-ring', '', 'preset'].includes(moduleSubType)">
                            <FilterSingleSelectDropDown :name="'style'" />
                        </div>
                        
                        
                        <div class="filter_box" v-if="['full-eternity-ring','tennis-bracelet','fashion-bracelet','fashion-earring','stud-earring','anniversary-ring','hoop-earring','tennis-necklace','solitaire-necklace','preset','toi-et-moi-ring'].includes(moduleSubType)">
                            <FilterSingleSelectDropDown :name="'carat'" />
                        </div>
                        <div class="filter_box" v-if="['gift_card'].includes(moduleSubType)">
                            <FilterSingleSelectDropDown :name="'category'" />
                        </div>
                        <div class="filter_box" v-if="!['cyo'].includes(moduleType) && !['couple-bands-ring'].includes(moduleSubType)">
                            <FilterSingleSelectDropDown :name="'shape'" />
                        </div>
                        <div class="filter_box" v-show="!isDiamondSelected">
                            <div v-if="['cyo'].includes(moduleType)">
                                <FilterSingleSelectDropDown :name="'shape'" />
                            </div>
                        </div>
                        <div class="filter_box" v-if="!['anniversary-ring', 'gift_card'].includes(moduleSubType)">
                            <FilterPriceRangeSlider :name="'price'" />
                        </div>
                        <div class="filter_box" v-if="['in-stock-ring'].includes(moduleSubType) && $country.is_india">
                            <FilterSingleSelectDropDown :name="'shipdate'" />
                        </div>
                        <div class="filter_box" v-if="!['cyo', 'preset', 'in-stock-ring'].includes(moduleType) && !$country.is_india">
                            <FilterSingleSelectDropDown :name="'shipdate'" />
                        </div>
                    </div>


                </div>
                <div class="filter_block_right for_desktop">
                    <div class="filter_box">
                        <FilterSortDropDown :name="'sort'" />
                    </div>
                   
                </div>
            </div>
        </div>
        <div v-if="showFilter" class="for_mobile sticky_btns">
            <CommonButtonPrimary  @emit-event="toggleFilterVisibilty()">
                <SvgHeaderSvg :type="'filter'" /> <span class="ms-2">FILTER RESULTS ({{ resultCount }})</span> 
            </CommonButtonPrimary>
        </div>
        <div v-else  class="for_mobile sticky_btns sticky_btns_mod">
            <CommonButtonPrimary @emit-event="toggleFilterVisibilty()" ><span>APPLY FILTERS </span></CommonButtonPrimary>
            <!-- ({{ appliedFiltersCount}}) -->
        </div>
        <div class="filter_tags_sort">

            <FilterPlateTags />

            <div class="sort for_mobile">
                <div class="prod_view">
                    <div class="d-flex">
                        <div class="grid_view" @click="changeViewType('grid')" :class="{'active': viewType === 'grid'}"><SvgHeaderSvg :type="'grid'" /></div>
                        <div class="grid_view" @click="changeViewType('list')" :class="{'active': viewType === 'list'}"><SvgHeaderSvg :type="'list'" /></div>
                    </div>
                </div>
                <div class="sort_drops">
                    <FilterSortDropDown :name="'sort'" />
                    <!-- 
                    <FilterSortDropDown 
                    v-if="!['cyo', 'preset'].includes(moduleType) && 
                    !$country.is_india" :name="'shipdate'
                    " /> -->
                </div>
            </div>
        </div>
       
    </div>
</template>

<script setup>
    const { viewType, page } = defineProps(['viewType', 'page'])
    import { cyolistStore }  from '@/stores/cyolist/cyolist';
    import { cyoStore }  from '@/stores/cyo/cyo';

    const emit = defineEmits(['changeViewType'])

    const listStore = cyolistStore();
    const cyo_Store = cyoStore();
    const route = useRoute();

    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType 

    const showFilter = ref(true)

    const resultCount = computed(() => listStore.getSettingListingResultCount() )

    let options = computed(()=> listStore.getSettingAllFilterOptions())
    
    // const appliedFiltersCount = computed(() => {
    //     let tags = []
    //     if(options.value){
    //         Object.keys(options.value).filter((items) => {
    //             let obj = options.value[items]
    //             if (items !== 'sort') {
    //                 if (items === 'price') {
    //                     if (obj.from != obj.min || obj.to != obj.max) {
    //                         tags.push(true)
    //                     }
    //                 }
    //                 else if(Array.isArray(obj)) {
    //                     obj.filter((item) => {
    //                         if (item.active) {
    //                             tags.push(true)
    //                         }
    //                     })
    //                 }
    //             }
    //         })
    //     }

    //     return tags.length
    // })
    

    const isDiamondSelected = computed(() => {
        if (moduleType === 'cyo') {
            return cyo_Store.getDiamond(moduleSubType)
        }
        return true
    })

    const paginateTitle = computed(() => {
                
        if (moduleSubType === 'ring') {

            return resultCount.value+' Engagement Ring Settings'
        }
        if (moduleSubType === 'earring') {

            return resultCount.value+' Earring Settings'
        }
        if (moduleSubType === 'pendant') {

            return resultCount.value+' Pendant Settings '
        }
        if (moduleSubType === 'band-ring') {

            return resultCount.value+' Wedding Rings'
        }
        if (moduleSubType === 'couple-bands-ring') {

            return resultCount.value+' Couple Rings'
        }

        if (moduleSubType === 'full-eternity-ring') {
            return resultCount.value+' Eternity Rings'
        }
        if (moduleSubType === 'tennis-bracelet') {
            return resultCount.value+' Tennis Bracelets'
        }
        if (moduleSubType === 'stud-earring' || 'fashion-earring') {
            return resultCount.value+' stud Earrings'
        }
        if (moduleSubType === 'anniversary-ring') {
            return resultCount.value+' Anniversary Rings'
        }
        if (moduleSubType === 'hoop-earring') {
            return resultCount.value+' Hoop Earrings'
        }
        if (moduleSubType === 'tennis-necklace') {
            return resultCount.value+' Tennis Necklace'
        }
        if (moduleSubType === 'solitaire-necklace') {
            return resultCount.value+' Solitaire Necklace'
        }
        if (moduleSubType === 'gift_card') {
            return resultCount.value+' Gift Cards'
        }
        if (moduleSubType === 'toi-et-moi-ring') {
            return resultCount.value+' Toi Et Moi Engagement Rings'
        }
        if (moduleSubType === 'preset') {
            return resultCount.value+' Pre-Designed Engagement Rings'
        }
        if (moduleSubType === 'in-stock-ring') {
            return resultCount.value+' Engagement Rings'
        }
        if (moduleSubType === 'in-stock-earring') {
            return resultCount.value+' Earrings'
        }
        if (moduleSubType === 'in-stock-pendant') {
            return resultCount.value+' Pendants'
        }
        return ''

    })

    const resetFilters = () => {
		window.location = window.location.pathname;
	};
    function toggleFilterVisibilty() {
        showFilter.value = !showFilter.value
        if(showFilter.value){
            window.scrollTo({ top: 0, behavior: 'smooth' });
            document.body.classList.remove('filter_open');
        }
        if(!showFilter.value){
            document.body.classList.add('filter_open');
        }
    }

    function changeViewType(type){
        emit('changeViewType', type)
    }
    
</script>

<style scoped>
.largesvg {
    transform: scale(1.3);
}
.active.grid_view .svg-head {
    color: var(--green);
}
.filter_block {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
.filter_block_left {
    display: flex;
    align-items: flex-start;
}
.sticky_btns button {
        width: 100%;
    }
.filter_block_right {
    display: flex;
    justify-content: end;
}

.filter_block_right .filter_box {
    margin-right: 0;
}
.filter_box {
    margin-right: 16px;
}
.sticky_btns button:focus{
    box-shadow: none;
}
.filter_tags_sort{
    margin: 2% 0;
}


@media(max-width: 992px){
    .col {
        padding: 0 0.5%;
    }
    .filter_block_mod {
        flex-wrap: wrap;
    }

    .filter_block_mod .filter_block_left {
        width: 100%;
    }

    .filter_block_mod .filter_block_right {
        width: 100%;
        margin-top: 13px;
    }
}
@media(max-width: 767px){
    
    .filter_header {
        display: flex !important;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        border-bottom: 1px solid #eaeaea;
        padding-bottom: 20px;
        margin-bottom: 20px;
        padding:4%;
    }

    .close_title {
        display: flex;
        align-items: center;
    }

    .close_title p {
        font-size: 14px;
        font-weight: 600;
    }

    .reset {
        margin-right: 20px;
    }

    .close_title svg.svg-head {
        height: 15px;
        margin-right: 10px;
    }
    .filter_block_left {
        flex-wrap: wrap;
        width: 100%;
    }

    .filter_box {
        width: 100%;
        margin-right: 0;
    }
    .sticky_btns.sticky_btns_mod {
        z-index: 99;
        padding: 0;
        /* box-shadow: none; */
        /* border-radius: 0; */
    }
   
    .sticky_btns.sticky_btns_mod button{
        border-radius: 0;
    }
   
    .reset .svg-head {
        height: 16px;
    }

    .reset {
        font-size: 14px;
        font-weight: 600;
    }
    .filter_close svg {
        /* transform: scale(1.3);
        margin-right: 10px; */
    }
    .current_active{
        padding: 0;
    }
    .filter_close {
        display: flex;
        align-items: baseline;
        justify-content: flex-end;
    }
    .sticky_btns {
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        z-index: 9;
        padding: 16px 16px 16px 16px;
        border-radius: 16px 16px 0px 0px;
        background-color: #fff;
        box-shadow: 0px -2px 10px 0px #00000026;

    }
    .filter_overlay {
        position: fixed;
        bottom: 0;
        height: auto;
        width: 100%;
        left: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 99;
        display: flex;
        align-items: flex-end;
        transition: 0.3s;
    }


    .mobile_overlay {
		position: fixed;
		top: 0;
		left: 0;
		height: 0;
		width: 100%;
		background: #0000007a;
		z-index: -1;
		transition: 0.1s;
	}
	.mobile_overlay.show_overlay {
		transition: 0.1s;
		height: 100%;
        z-index: 99;
	}

   
 

    .filter_block {
        background: #fff;
        width: 100%;
        margin: 0 auto;
        border-radius: 15px 15px 0 0;
        margin-bottom: 40px;
        height: auto;
        /* overflow: auto; */
        overflow: hidden;
        max-height: 80vh;
        padding-bottom: 30%;
    }
    
    .filters_container{
        padding: 4%;
        padding-top:0;
        max-height: 80vh;
        overflow-y: scroll;
        padding-bottom: 100px;
    }

    /* ////////////////////// */
    .sort {
        display: flex !important;
        align-items: center;
        justify-content: space-between;
        background: #f5f5f5;
        width: 100%;
        padding: 0 10px;
        height: 45px;
        border-radius: 8px;
    }

    .grid_view {
        margin-right: 10px;
    }
    
    .cyo_jew_mobile.filter_overlay {
        transition: 0.3s;
        position: fixed;
        bottom: -100%;
        height: 0;
    }
}

</style>